/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef } from 'react';
import useOutsideClick from 'shared/hooks/useOutsideClick';
import { createPortal } from 'react-dom';

// Load Icons
import { ArrowDownIcon } from 'shared/components/Icons';
import { NavLink } from 'react-router-dom';

const Dropdown = ({
  title,
  toggleContent,
  className,
  containerClass,
  size = 'initial',
  children,
  disabled,
  onClickTitle,
  contentClassName,
  withPortal = true,
  outStateOpen,
  setOutStateOpen,
  disableOutSideClick,
}) => {
  const [localOpen, setLocalOpen] = useState(false);
  const open = outStateOpen !== undefined ? outStateOpen : localOpen;
  const setOpen = setOutStateOpen !== undefined ? setOutStateOpen : setLocalOpen;
  const dropdown = useRef();
  const dropdownContent = useRef();

  const toggleDropdown = e => {
    !disabled && setOpen(!open);
  };

  useOutsideClick([dropdown, dropdownContent], () => {
    if (!disableOutSideClick) {
      setOpen(false);
    }
  });

  return (
    <div className={`dropdown-container ${containerClass || ''} dropdown-container-${size}`}>
      <div ref={dropdown} className={`dropdown ${className} ${open ? 'active' : ''}`}>
        {title && (
          <div
            className={`drop-toggle d-flex align-items-center cursor-${disabled ? 'default' : 'pointer'}`}
            role='presentation'
          >
            <span className='text-nowrap' onClick={onClickTitle}>
              {title}
            </span>{' '}
            <ArrowDownIcon onClick={toggleDropdown} className='ml-md-5 ml-0 drop-icon' />
          </div>
        )}
        {toggleContent && <div onClick={toggleDropdown}>{toggleContent(open)}</div>}
        {open && (
          <DropDownContent
            onMenuClick={() => setOpen(false)}
            refElement={dropdownContent}
            offset={dropdown.current?.getBoundingClientRect()}
            className={`drop-content-${size} ${contentClassName}`}
            withPortal={withPortal}
          >
            {children}
          </DropDownContent>
        )}
      </div>
    </div>
  );
};

const DropDownContent = ({ onMenuClick, refElement, offset, children, className, withPortal }) => {
  const dropComponent = () => {
    const style =
      withPortal && offset
        ? { top: offset.top + offset.height, left: offset.right - offset.width - offset.width / 2 }
        : {};
    return (
      <div
        ref={refElement}
        style={style}
        className={`drop-content ${className}`}
        onClick={onMenuClick}
        role='presentation'
      >
        {children}
      </div>
    );
  };

  return withPortal ? createPortal(dropComponent(), document.querySelector('#portal')) : dropComponent();
};

Dropdown.Item = ({ onClick, children, active, path, className }) => {
  const handleClick = () => onClick && onClick();

  const classes = `drop-item d-block text-dark ${active ? 'active' : ''} ${className}`;

  const content = path ? (
    <NavLink to={path} className={classes}>
      {children}
    </NavLink>
  ) : (
    <div className={classes} onClick={handleClick} role='presentation'>
      {children}
    </div>
  );

  return content;
};

export default Dropdown;
